// localStorage-basierter Offline Store (einfacher als IndexedDB)

const STORAGE_KEYS = {
  PENDING_CHANGES: 'prosys_pending_changes',
  PENDING_PHOTOS: 'prosys_pending_photos',
  CACHED_DATA: 'prosys_cached_data'
};

// Helper: Daten aus localStorage lesen
const getStorageItem = (key) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : [];
  } catch (error) {
    console.error('localStorage read error:', error);
    return [];
  }
};

// Helper: Daten in localStorage schreiben
const setStorageItem = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    console.error('localStorage write error:', error);
  }
};

// Offline Change tracken
export const queueOfflineChange = async (type, action, data) => {
  const changes = getStorageItem(STORAGE_KEYS.PENDING_CHANGES);
  
  const newChange = {
    id: Date.now() + Math.random(), // Unique ID
    type,
    action,
    data,
    timestamp: Date.now(),
    synced: false
  };
  
  changes.push(newChange);
  setStorageItem(STORAGE_KEYS.PENDING_CHANGES, changes);
  
  console.log('Offline change queued:', type, action);
  return newChange.id;
};

// Pending Changes holen
export const getPendingChanges = async () => {
  const changes = getStorageItem(STORAGE_KEYS.PENDING_CHANGES);
  return changes.filter(c => !c.synced);
};

// Change als synced markieren
export const markChangeSynced = async (id) => {
  const changes = getStorageItem(STORAGE_KEYS.PENDING_CHANGES);
  const updated = changes.map(c => 
    c.id === id ? { ...c, synced: true } : c
  );
  setStorageItem(STORAGE_KEYS.PENDING_CHANGES, updated);
};

// Offline-Status prüfen
export const isOnline = () => {
  return navigator.onLine;
};

// Pending Photos Queue
export const queuePhoto = async (photo) => {
  const photos = getStorageItem(STORAGE_KEYS.PENDING_PHOTOS);
  
  // Konvertiere Blob zu Base64 für localStorage
  const reader = new FileReader();
  return new Promise((resolve) => {
    reader.onloadend = () => {
      const newPhoto = {
        id: Date.now() + Math.random(),
        todoId: photo.todoId || null,
        protocolItemId: photo.protocolItemId || null,
        base64: reader.result,
        filename: photo.filename,
        timestamp: Date.now(),
        synced: false
      };
      
      photos.push(newPhoto);
      setStorageItem(STORAGE_KEYS.PENDING_PHOTOS, photos);
      resolve(newPhoto.id);
    };
    reader.readAsDataURL(photo.blob);
  });
};

export const getPendingPhotos = async () => {
  const photos = getStorageItem(STORAGE_KEYS.PENDING_PHOTOS);
  return photos.filter(p => !p.synced);
};

export const markPhotoSynced = async (id) => {
  const photos = getStorageItem(STORAGE_KEYS.PENDING_PHOTOS);
  const updated = photos.map(p => 
    p.id === id ? { ...p, synced: true } : p
  );
  setStorageItem(STORAGE_KEYS.PENDING_PHOTOS, updated);
};

// Cache-Funktionen (optional für später)
export const updateCache = async (table, data) => {
  const cache = getStorageItem(STORAGE_KEYS.CACHED_DATA);
  cache[table] = data;
  setStorageItem(STORAGE_KEYS.CACHED_DATA, cache);
};

export const getFromCache = async (table) => {
  const cache = getStorageItem(STORAGE_KEYS.CACHED_DATA);
  return cache[table] || [];
};

export default {
  queueOfflineChange,
  getPendingChanges,
  markChangeSynced,
  queuePhoto,
  getPendingPhotos,
  markPhotoSynced,
  isOnline
};
